import { create } from "zustand";

interface UIState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  setSidebarCollapsed: (v: boolean) => void;
  mobileSidebarOpen: boolean;
  openMobileSidebar: () => void;
  closeMobileSidebar: () => void;
  toggleMobileSidebar: () => void;
}

const KEY = "workman.sidebar";

const initial = typeof window !== "undefined" && window.localStorage.getItem(KEY) === "1";

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: initial,
  toggleSidebar: () =>
    set((s) => {
      const v = !s.sidebarCollapsed;
      try {
        window.localStorage.setItem(KEY, v ? "1" : "0");
      } catch {
        /* ignore */
      }
      return { sidebarCollapsed: v };
    }),
  setSidebarCollapsed: (v) => set({ sidebarCollapsed: v }),
  mobileSidebarOpen: false,
  openMobileSidebar: () => set({ mobileSidebarOpen: true }),
  closeMobileSidebar: () => set({ mobileSidebarOpen: false }),
  toggleMobileSidebar: () =>
    set((s) => ({ mobileSidebarOpen: !s.mobileSidebarOpen })),
}));
